const shipperTypes = {
  COMPANY: 'company',
  PERSONAL: 'personal'
};
export default shipperTypes;
